import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import styles from './requirement-item.scss';
import checkIcon from '../5-3-a-standard-secondary.svg';

import { Text, TextButton } from 'wix-style-react';

const RequirementItem = ({ titleKey, linkLabel, link, t }) => (
  <div
    data-hook="mi-facebook-catalog-requirement-item"
    className={styles.container}
  >
    <img className={styles.icon} src={checkIcon} alt="" />
    <div>
      <div className={styles.title}>
        <Text size="small">{t(titleKey)}</Text>
      </div>
      <div className={styles[`action-button`]}>
        <TextButton
          onClick={() => {
            window.open(link, '_blank');
          }}
          size="small"
        >
          {t(linkLabel)}
        </TextButton>
      </div>
    </div>
  </div>
);

RequirementItem.propTypes = {
  titleKey: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(RequirementItem);
